import React from 'react';

import PropTypes from 'prop-types';

import FieldReplacedValue from '../FieldReplacedValue';

/** A summarised change through its `renderer`, or "Field replaced" — never its raw value. */
const AuditSummaryValue = ({
  renderer: SummaryRenderer = null,
  change,
  row = null,
  detail = null,
}) =>
  SummaryRenderer ? (
    <SummaryRenderer change={change} detail={detail} row={row} />
  ) : (
    <FieldReplacedValue />
  );

AuditSummaryValue.propTypes = {
  change: PropTypes.object.isRequired,
  renderer: PropTypes.elementType,
  row: PropTypes.object,
  detail: PropTypes.object,
};

export default AuditSummaryValue;
